import { CaretSortIcon } from '@radix-ui/react-icons';
import { Link } from 'react-router';

import {
  AuroraText,
  Avatar,
  AvatarFallback,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabelClamp,
  DropdownMenuTrigger,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@app-evolution-cms/element-ui';

import { config } from '../../config';
import { THEME, useTheme } from '../../theme-provider';

const EP_CLIENT_APP = config().EP_CLIENT_APP;

export function NavHeader() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton id="PER-navigation-sidebarHeader-nickCMS" size="lg">
              <Nick />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56"
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabelClamp className="w-full" text="Sistemas gestionados" />
            <DropdownMenuItem>
              <Link
                id="PER-navigation-sidebarHeader-aeLink"
                rel="noopener noreferrer"
                target="_blank"
                to={EP_CLIENT_APP}
              >
                App GBM
              </Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}

function Nick() {
  const { theme } = useTheme();

  return (
    <div className="flex w-full items-center gap-4">
      <Avatar className="size-8">
        <AvatarFallback className="bg-foreground text-background">
          <span className="scale-y-90 text-[11px] font-[700] tracking-wide text-white dark:text-black">
            GBM
          </span>
        </AvatarFallback>
      </Avatar>
      <div className="grid max-w-48 flex-1 text-left leading-tight">
        <span className="truncate text-sm font-medium">Personalization Platform</span>
        <AuroraText
          colors={
            theme === THEME.DARK
              ? ['#2563eb', '#ffffff', '#fef08a']
              : ['#2563eb', '#000000', '#f59e0b']
          }
          className="text-[12px] tracking-wide"
        >
          Content & Labs
        </AuroraText>
      </div>
      <CaretSortIcon className="ml-auto size-4" />
    </div>
  );
}
